import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { createTheme } from '@mui/material';

import { useSelector } from 'react-redux';
import CustomTableContainer from '../Common/Table/CustomTableContainer';
import EditDeviceModal from '../Modal/editDeviceModal';
import DeviceView from './deviceView';

import { FilterManager } from '../../util/filters/filterManager';
import { FILTER_TYPE } from '../../util/filters/filterConstants';

const theme_bp = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 680,
      md: 850,
      lg: 1200,
      xl: 1536,
    },
  },
});

const useStyles = makeStyles({

});

export default function DeviceTable(props) {
  const [processedDevices, setProcessedDevices] = useState([]);
  const deviceData = useSelector((state) => state.device.deviceData);
  const userInsightsData = useSelector((state) => state.userInsights.userInsightsData);
  const groupData = useSelector((state) => state.group.groupData);
  const [modalData, setModalData] = useState({ open: false });
  const [groupMap, setGroupMap] = useState({});
  const filterManagerRef = useRef(null);
  if (!filterManagerRef.current) {
    filterManagerRef.current = FilterManager.Builder
      .addFilter(FILTER_TYPE.DEVICE.UPDATE_STATUS, true)
      .addFilter(FILTER_TYPE.DEVICE.ID, true)
      .addFilter(FILTER_TYPE.DEVICE.NAME, true)
      .addFilter(FILTER_TYPE.DEVICE.ORIGINAL_NAME, false)
      .addFilter(FILTER_TYPE.DEVICE.LOCATION_NAME, true)
      .addFilter(FILTER_TYPE.DEVICE.LOCATION_DESC, false)
      .addFilter(FILTER_TYPE.DEVICE.LATITUDE, false)
      .addFilter(FILTER_TYPE.DEVICE.LONGITUDE, false)
      .addFilter(FILTER_TYPE.DEVICE.LAST_SEEN, true)
      .addFilter(FILTER_TYPE.DEVICE.LAST_INSIGHT_HOUR, true)
      .addFilter(FILTER_TYPE.DEVICE.LAST_IMAGE_HOUR, false)
      .addFilter(FILTER_TYPE.DEVICE.LAST_CYCLE_COUNT_HOUR, true)
      .addFilter(FILTER_TYPE.DEVICE.CYCLE_TIME, false)
      .addFilter(FILTER_TYPE.DEVICE.TRIGGER_NUMBER, false)
      .addFilter(FILTER_TYPE.DEVICE.MEMORY_REMAINING, false)
      .addFilter(FILTER_TYPE.DEVICE.CYCLE_COUNT, false)
      .addFilter(FILTER_TYPE.DEVICE.IMAGES_PROCESSED, false)
      .addFilter(FILTER_TYPE.DEVICE.GROUPS, false)
      .addFilter(FILTER_TYPE.DEVICE.BATTERY_VOLTAGE, false)
      .addFilter(FILTER_TYPE.DEVICE.BATTERY_STATUS, true)
      .addFilter(FILTER_TYPE.DEVICE.MAP_BUTTON, false)
      .build()
  }
  const filterManager = filterManagerRef.current;

  const handleClick = (event, row) => {
    const newModalData = {
      open: true,
      deviceId: row.device_id
    };
    setModalData(newModalData);
  }

  const handleClose = () => {
    setModalData({ open: false });
  }

  const getMobileElement = (row) => {
    return (
      <DeviceView device={row.device} row={row} />
    )
  }

  useEffect(() => {
    if (deviceData && userInsightsData) {
      const userInsightMap = {};
      const currentDate = Date.now();
      for (const device of deviceData) {
        userInsightMap[device.device_id.toString()] = {
          lastInsightMS: Infinity,
          lastImageMS: Infinity
        };
      }
      for (const insight of userInsightsData) {
        const existingMetric = userInsightMap[insight.device_id.toString()];
        userInsightMap[insight.device_id.toString()] = {
          lastInsightMS: Math.min(existingMetric.lastInsightMS, Math.abs(currentDate - (new Date(insight.time_stamp)).getTime())),
          lastImageMS: Math.min(existingMetric.lastImageMS, Math.abs(currentDate - (new Date(insight.file_ctime)).getTime())),
        }
      }
      setProcessedDevices(
        deviceData.map((device, index) => {
          const insightMetrics = userInsightMap[device.device_id.toString()];
          return {
            ...filterManager.generateDataMap(device, groupMap[device.device_id], undefined, insightMetrics),
            id: index,
            device
          }
        })
      );
    }

  }, [deviceData, userInsightsData, groupMap]);

  useEffect(() => {
    if (deviceData && groupData) {
      const groupDevice = {};
      for (const group of groupData) {
        for (const device of group.devices) {
          if (!(device in groupDevice)) {
            groupDevice[device] = [];
          }
          groupDevice[device].push(group.group_name);
        }
      }
      setGroupMap(groupDevice);
    }
  }, [deviceData, groupData]);

  return (
    <>
      <CustomTableContainer
        defaultOrder="desc"
        defaultOrderHeader={FILTER_TYPE.DEVICE.ID}
        headers={filterManager.getHeaders()}
        filterManager={filterManager}
        rowData={processedDevices}
        paginationOptions={[5, 10, 25, 50, 100]}
        defaultPaginationOption={25}
        clickAction={handleClick}
        getMobileElement={getMobileElement}
        swipeable={true}
        insightsTable={false}
        AdditionalToolbar={false}
        UnsavedChangesSnackbar={false}
      />
      {
        modalData && modalData.deviceId &&
        (<EditDeviceModal
          device={modalData.deviceId}
          open={modalData.open}
          handleClose={handleClose}
        />)
      }

    </>
  );
}
